import moment from 'moment-timezone';
import { useMemo, useState } from 'react';
import { TimezoneOption } from '../types/booking';
import { ContinentTimezones } from '../types/rest';

export const useTimezone = (timezoneData: ContinentTimezones[], country: string, fallbackTimezone: string) => {
	const timezoneOptions = useMemo(() => {
		return timezoneData.reduce((acc, { continent, timezones }) => {
			timezones.forEach((timezone) => {
				const option: TimezoneOption = {
					value: timezone.id,
					label: timezone.label,
					meta: timezone.gmt_offset,
					group: continent,
				};
				acc.push(option);
			});

			return acc;
		}, [] as TimezoneOption[]);
	}, [timezoneData]);

	const timezoneInOptions = (timezoneValue: string): boolean => !!timezoneOptions.find((option) => option.value === timezoneValue);

	const [timezone, setTimezone] = useState(() => {
		// A: Check if guessed timezone exists in our data, otherwise return the default
		const guessedTimezone = moment.tz.guess();
		if (timezoneInOptions(guessedTimezone)) {
			return guessedTimezone;
		}

		// B: Get the timezone for the user's country if available
		const timezonesByCountry = moment.tz.zonesForCountry(country);
		if (timezonesByCountry && timezonesByCountry.length > 0 && timezoneInOptions(timezonesByCountry[0])) {
			return timezonesByCountry[0];
		}

		// C: Fallback to the first timezone in the options list
		return fallbackTimezone;
	});

	return { timezone, timezoneOptions, setTimezone };
};
